module.exports = __webpack_public_path__ + "static/ledeck_01-059b3b0eaaf5022bd4370b7317b1ac67.jpg";